import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Invoice, UpdateInvoiceDeliveryDatePayload } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['payload', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'UPDATE_INVOICE_DELIVERY_DATE_',
  }
);

export interface UpdateInvoiceDeliveryDateState {
  data: Invoice[];
  loading: boolean;
  errorMessage: string | null;
}

export interface UpdateInvoiceDeliveryDateRequestAction {
  payload: UpdateInvoiceDeliveryDatePayload;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: UpdateInvoiceDeliveryDateState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: UpdateInvoiceDeliveryDateState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: UpdateInvoiceDeliveryDateState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: UpdateInvoiceDeliveryDateState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: UpdateInvoiceDeliveryDateState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const updateInvoiceDeliveryDate = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const UpdateInvoiceDeliveryDateTypes = Types;
export const UpdateInvoiceDeliveryDateActions = Creators;
